module.exports = __webpack_public_path__ + "static/img/casino-pc-thum02.5ba0a0a.png";